import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fc3470b2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=fc3470b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3470b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc3470b2')) {
      api.createRecord('fc3470b2', component.options)
    } else {
      api.reload('fc3470b2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fc3470b2&scoped=true&", function () {
      api.rerender('fc3470b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/cityRewardSettlement/index.vue"
export default component.exports